/**
 * locateFile is executed by the emscripten runtime to resolve the location of files.
 * It allows loading of wasm-files from our firebase domain, while embedding a web
 * component to a 3rd party website. Without this, the wasm files would be loaded from the 3rd party domain.
 * https://emscripten.org/docs/api_reference/module.html
 * https://github.com/emscripten-core/emscripten/issues/10434
 *
 * Uses import.meta.url to derive the base URL from the worker's own script location,
 * which is always on the correct origin — even when embedded as a web component on a
 * 3rd party site. This avoids depending on Angular's fileReplacements which don't
 * propagate to separately-bundled worker entry points.
 */
const baseUrl = new URL(import.meta.url).origin

export const locateFile = (path: string) => `${baseUrl}/assets/${path}`
